import { render, staticRenderFns } from "./OtSelect.vue?vue&type=template&id=1162fe6e&"
import script from "./OtSelect.vue?vue&type=script&lang=js&"
export * from "./OtSelect.vue?vue&type=script&lang=js&"
import style0 from "./OtSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports